export default __webpack_public_path__ + "static/nav-logo-08d927f2ec13dbeed3a21a9584329da8.png";